import {ssrSafeLocation} from '@github-ui/ssr-utils'

/**
 * Minimal repository shape the shared picker needs. Intentionally decoupled from
 * copilot-chat's richer repository types so this package carries no dependency on
 * copilot-chat. `name` holds the `owner/repo` (nameWithOwner) form because the
 * underlying `@github-ui/repos-selector` renders the `name` field, and downstream
 * prompt/attachment serialization needs the full name and URL.
 */
export interface Repository {
  /** GitHub repository database id. */
  id: number
  /** `owner/repo` — required by repos-selector and used for display + serialization. */
  name: string
  /** True for private repositories; drives the lock icon in the picker. */
  private: boolean
}

/**
 * Absolute URL for a repository, derived from its `owner/repo` name against the
 * current host origin. Using the runtime origin (rather than a hardcoded
 * `github.com`) keeps the link correct on GHES/proxima tenants where the host
 * differs. Falls back to `github.com` when no origin is available (e.g. SSR
 * before the server location is set).
 */
export function repositoryURL(repo: Repository): string {
  const origin = ssrSafeLocation.origin || 'https://github.com'
  return new URL(`/${repo.name}`, origin).href
}
